export default __webpack_public_path__ + "static/media/workout.77a23b86.svg";